import { render } from "./CartDrawerProducts.vue?vue&type=template&id=6b676470"
import script from "./CartDrawerProducts.vue?vue&type=script&lang=js"
export * from "./CartDrawerProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__